import script from "./property-lookup-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./property-lookup-page.vue?vue&type=script&setup=true&lang=ts"

import "./property-lookup-page.vue?vue&type=style&index=0&id=35797ce6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35797ce6"]])

export default __exports__